import {
  Component,
  ChangeDetectionStrategy,
  input,
  model,
  output,
  effect,
  viewChild,
  inject,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { SwitchLanguageService } from '../../services';
import { DATEPICKER_FORMAT_M, MAX_DATE_M, MIN_DATE_M } from '@core-utils';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MatDatepicker,
  MatDatepickerInputEvent,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatNativeDateModule,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { NgClass } from '@angular/common';
import { ValidationFormComponent } from '../validation-form/validation-form.component';
import { FormTimepickerComponent } from '../form-timepicker/form-timepicker.component';

@Component({
  selector: 'ui-form-datepicker-timezone',
  imports: [
    MatFormFieldModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    ValidationFormComponent,
    NgClass,
    FormTimepickerComponent,
  ],
  templateUrl: './form-datepicker-timezone-m.component.html',
  styleUrl: './form-datepicker-timezone-m.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: DATEPICKER_FORMAT_M },
    provideNativeDateAdapter(),
  ],
})
export class FormDatepickerTimezoneMComponent {
  private dateAdapter = inject<DateAdapter<Date>>(DateAdapter);
  private switchLanguageService = inject(SwitchLanguageService);

  pickerMat = viewChild.required<MatDatepicker<Date>>('pickerMat');
  control = input<AbstractControl>();
  minDate = input<Date>(MIN_DATE_M);
  maxDate = input<Date>(MAX_DATE_M);
  placeholderDate = input<string>('');
  global = input<boolean>(false);
  placeholderTime = input<string>('');
  description = input<string>();
  selectedDate = model<string | Date | null>(new Date());
  dateChange = output<string | Date | null>();

  constructor() {
    effect(() => {
      this.switchLanguageService.currentLang();
      this.dateAdapter.setLocale(this.switchLanguageService.currentLang());
    });
  }

  get formControl(): FormControl {
    return this.control() as FormControl;
  }

  onDateChange(event: MatDatepickerInputEvent<Date>) {
    if (event?.value) {
      this.selectedDate.set(event.value);
      this.dateChange.emit(event?.value.toISOString());
    }
  }

  onTimeChange(event: Date) {
    this.dateChange.emit(event.toISOString());
  }

  onButtonClick() {
    this.pickerMat().open();
  }
}
